// Central test-id registry for SecuSource
export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  companies: "nav-companies",
  professionals: "nav-professionals",
  teams: "nav-teams",
  pricing: "nav-pricing",
  contact: "nav-contact",
  about: "nav-about",
  login: "nav-login",
  registerStaff: "nav-register-staff",
  registerCompany: "nav-register-company",
  logout: "nav-logout",
  dashboard: "nav-dashboard",
};

export const HOME = {
  emergentLink: "emergent-link",
  heroFind: "hero-find-staff-btn",
  heroJoin: "hero-join-pro-btn",
  heroCompany: "hero-company-login-btn",
  ctaRegisterStaff: "cta-register-staff-btn",
  ctaRegisterCompany: "cta-register-company-btn",
  ctaRequestDemo: "cta-request-demo-btn",
};

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  loginError: "login-error",
  registerStaffSubmit: "register-staff-submit-btn",
  registerCompanySubmit: "register-company-submit-btn",
};

export const STAFF = {
  profileForm: "staff-profile-form",
  uploadLicence: "upload-licence-btn",
  uploadQualification: "upload-qualification-btn",
  uploadPhoto: "upload-photo-btn",
  createTeam: "create-team-btn",
  applyJob: "apply-job-btn",
  jobsList: "staff-jobs-list",
};

export const COMPANY = {
  searchProfessionals: "search-professionals-btn",
  filterCounty: "filter-county-select",
  filterRole: "filter-role-select",
  requestBooking: "request-booking-btn",
  unlockContact: "unlock-contact-btn",
  payFee: "pay-fee-btn",
  bookingsList: "company-bookings-list",
};

export const ADMIN = {
  dashboard: "admin-dashboard",
  pendingStaff: "admin-pending-staff",
  pendingCompanies: "admin-pending-companies",
  approveBtn: "admin-approve-btn",
  rejectBtn: "admin-reject-btn",
  postJob: "admin-post-job-btn",
};

export const PRICING = {
  workersInput: "pricing-workers-input",
  hoursInput: "pricing-hours-input",
  rateInput: "pricing-rate-input",
  calculateBtn: "pricing-calculate-btn",
  result: "pricing-result",
};

export const CONTACT = {
  form: "contact-form",
  submit: "contact-submit-btn",
};
